import React from "react";
import {Accordeon} from "../../../controls";

export default function Videos({activity}) {
  // pre-render
  const videos = (activity.videos || []).map((video, index) => {
    return <Video key={index} video={video} />
  })
  // render
  if(videos.length === 0) {
    return null;
  }
  return <>
    <Accordeon title="Videos" expanded={true}>
      <div className="videos">{videos}</div>
    </Accordeon>
  </>
}

function Video({video}) {
  const src = getEmbedUrl(video.url);
  return (
    <div className="video">
      <iframe width="280" height="158" src={src} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>  
    </div>
  );
}

function getEmbedUrl(url) {
  const parts = url.split("/");
  const videoId = parts[parts.length - 1];
  return `https://www.youtube.com/embed/${videoId}`;
}